import { useEffect, useState } from 'react';
function useDebounce(func, delay = 500) {
    const [timer, setTimer] = useState();
    useEffect(() => {
        return () => clearTimeout(timer);
    }, [timer]);
    return (args) => {
        const newTimer = setTimeout(() => {
            func(args);
        }, delay);
        clearTimeout(timer);
        setTimer(newTimer);
    };
}
export default useDebounce;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlRGVib3VuY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvaG9va3MvdXNlRGVib3VuY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxRQUFRLEVBQUUsTUFBTSxPQUFPLENBQUM7QUFFNUMsU0FBUyxXQUFXLENBQW9DLElBQW1DLEVBQUUsS0FBSyxHQUFHLEdBQUc7SUFDcEcsTUFBTSxDQUFDLEtBQUssRUFBRSxRQUFRLENBQUMsR0FBRyxRQUFRLEVBQWtCLENBQUM7SUFFckQsU0FBUyxDQUFDLEdBQUcsRUFBRTtRQUNYLE9BQU8sR0FBRyxFQUFFLENBQUMsWUFBWSxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQ3JDLENBQUMsRUFBRSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUM7SUFFWixPQUFPLENBQUMsSUFBZ0IsRUFBRSxFQUFFO1FBQ3hCLE1BQU0sUUFBUSxHQUFHLFVBQVUsQ0FBQyxHQUFHLEVBQUU7WUFDN0IsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO1FBQ2YsQ0FBQyxFQUFFLEtBQUssQ0FBQyxDQUFDO1FBQ1YsWUFBWSxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQ3BCLFFBQVEsQ0FBQyxRQUFRLENBQUMsQ0FBQztJQUN2QixDQUFDLENBQUM7QUFDTixDQUFDO0FBRUQsZUFBZSxXQUFXLENBQUMifQ==